import * as AppActions from './App';
import * as CompaniesActions from './Companies';
import * as CompanyActions from './Company';
import { push } from 'connected-react-router'
import axios from 'axios';
import config from '../../shared/config';

export const EventActions = {
  SET_ATTRIBUTE: "EVENT_SET_ATTRIBUTE"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setEventAttribute = (key, value) => {
  return {
    type: EventActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const companySelected = (slug) => (dispatch, getState) => {
  dispatch( CompanyActions.resetState() );
  dispatch( push(`/events/${config.eventSlug}/companies/${slug}`) );
}

export const companySelectedChatNow = (slug) => (dispatch, getState) => {
  dispatch( CompanyActions.resetState() );
  dispatch( CompanyActions.setCompanyAttribute('startChat', true) );
  dispatch( push(`/events/${config.eventSlug}/companies/${slug}`) );
}

export const loadEventData = ( eventId, backdrop ) => async (dispatch, getState) => {
  console.log("[DEBUG] Load event data - ajax", eventId);
  if(backdrop) dispatch( AppActions.setLoading(true) );
  await axios.get(`/api/events/${eventId}`)
    .then((response) => {
      console.log("Event response", response);
      dispatch( setEventAttribute('data', response.data.event));
      dispatch( CompaniesActions.setCompaniesAttribute('items', response.data.companies));
      dispatch( setEventAttribute('loaded', true));
      dispatch( AppActions.setLoading(false) );
    })
    .catch((error) => {
      console.log("Error loading event data", error);
    })
}

export const checkIn = ( eventId ) => async (dispatch, getState) => {
  await axios.post(`/api/events/${eventId}/check_in`)
    .then((response) => {
      console.log("Check in response", response);
    })
    .catch((error) => {
      console.log("Unable to check in", error);
    })
}


export const setEventId = (eventId) => async (dispatch) => {
  dispatch( setEventAttribute('eventId', eventId) );
  // populate event based on window.appConfig - for googlebot
  dispatch( setEventAttribute('data', window.appConfig.event));
  dispatch( setEventAttribute('questions', window.appConfig.questions));
  dispatch( CompaniesActions.setCompaniesAttribute('items', window.appConfig.companies));
  dispatch( setEventAttribute('loaded', true));
  // end of populate based on server rendered data
  await dispatch( loadEventData( eventId, true ) ); // hydrate!
  setInterval( () => {
    dispatch( loadEventData( eventId, false ) ); // update every 30 seconds
  }, 30000);
}

export const enableBG = () => {
  return setEventAttribute('bg', true);
}

export const disableBG = () => {
  return setEventAttribute('bg', false);
}

export const showRegisterModal = () => {
  return setEventAttribute('showRegister', true);
}

export const hideRegisterModal = () => {
  return setEventAttribute('showRegister', false);
}
